import { SubmitEvent, SubmitEventHandler } from 'react';

import { useElements, useStripe } from '@stripe/react-stripe-js';
import { enqueueSnackbar } from 'notistack';

import { apiStatusStore } from '../../shared/stores/apiStatusStore';

export const useStripePaymentSubmit = (returnUrl: string) => {
  const stripe = useStripe();
  const elements = useElements();

  const { loadingStart, loadingEnd } = apiStatusStore;

  const handleSubmit: SubmitEventHandler<HTMLFormElement> = async (
    event: SubmitEvent<HTMLFormElement>,
  ) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    loadingStart(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
    });

    if (error) {
      enqueueSnackbar(error.message || 'Something went wrong. Please try again later', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }

    loadingEnd(true);
  };

  return { handleSubmit };
};
